import { PageTitle } from '../../../../_metronic/layout/core';
import { useIntl } from 'react-intl';
import GeneralDetail from '../../../modules/custom/accounts/datatransfer/GeneralDetail';
import { useAppSelector } from "../../../../redux/hooks"
import { useEffect, useState } from 'react';
import { getDataConnector, getDataConnectorGlobal } from '../../../modules/custom/Dashboard/requests/request';
import Cloudconnectoredge from '../../../modules/custom/Dashboard/components/graficosverticales/ConnectorEdge';
import { useAuth } from '../../../modules/auth';
import Pruebachart from '../../../modules/custom/Dashboard/components/graficosverticales/widgetconnectores';
import ModalSwal from '../../../modules/permisoDenegado/Modalswal';
import { useNavigate } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';

type datos = {
    Available_DTR_VPN?: any,
    DateUpdate_DTR_VPN?: any,
    exceeded_DTR_VPN?: any,
    Total_DTR_VPN?: any,
    Available_DTR_CPR?: any,
    DateUpdate_DTR_CPR?: any,
    exceeded_DTR_CPR?: any,
    Total_DTR_CPR?: any,
    Subscription?: any,
    Available_DTR_EDG?: any
    Total_DTR_EDG?: any
    exceeded_DTR_EDG?: any
    start?: any,
    end?: any,
    error?: any

}
const DataTransfer = () => {
    const Id = useAppSelector(state => state.SuscriptionSlice.id)
    const Type = useAppSelector(state => state.CloudSlice.Type)
    const tenant = useAppSelector(state => state.TenantSlice.id)
    const ListaPermisosTenant = useAppSelector(state => state.ListPermissionSlice.Permissions)
    const nameregion = useAppSelector(state => state.RegionSlice.name)
    const FlagReg = useAppSelector(state => state.FlagSlice.value)

    const { currentUser } = useAuth()

    let mesSiguiente

    var date = new Date();
    var currentMonth = date.getMonth();
    var nextMonth = ++currentMonth;
    var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1)

    /*mesactualstring = nextMonthFirstDay.getFullYear() + "-" + (nextMonthFirstDay.getMonth()+1)+ "-" +nextMonthFirstDay.getDate()*/
    mesSiguiente = nextMonthFirstDay.getDate() + "/" + (nextMonthFirstDay.getMonth() + 1) + "/" + nextMonthFirstDay.getFullYear()


    /************************************************************************************************ */
    const [DataAvailable, setDataAvailable] = useState({
        start: '',
        end: '',
        Available_DTR_VPN: 0,
        DateUpdate_DTR_VPN: '',
        exceeded_DTR_VPN: 0,
        Total_DTR_VPN: 1,
        Available_DTR_CPR: 0,
        DateUpdate_DTR_CPR: '',
        exceeded_DTR_CPR: 0,
        Total_DTR_CPR: 1,

    })

    const [prueba, setprueba] = useState([{
        Available_DTR_VPN: 0,
        DateUpdate_DTR_VPN: '',
        exceeded_DTR_VPN: 0,
        Total_DTR_VPN: 0,
        Available_DTR_EDG: 0,
        DateUpdate_DTR_EDG: '',
        exceeded_DTR_EDG: 0,
        Total_DTR_EDG: 0,
        Subscription: '',
        start: '',
        end: '',
        error: ''

    }])

    const [DataAvailablep, setDataAvailablep] = useState<datos[]>([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (FlagReg === true) {
                    if (Type !== 'CloudGlobal' && currentUser?.ListPermiso?.includes('Ctx.DataUsage')) {
                        if (tenant === 0) {
                            const available = await getDataConnector(Id, 'Ctx.DataUsage', Type, nameregion);
                            if (available.data && available.data.error === 'id suscription invalido') {
                                setDataAvailable({
                                    start: '', end: '', Available_DTR_VPN: 0, DateUpdate_DTR_VPN: '', exceeded_DTR_VPN: 0, Total_DTR_VPN: 1,
                                    Available_DTR_CPR: 0,
                                    DateUpdate_DTR_CPR: '',
                                    exceeded_DTR_CPR: 0,
                                    Total_DTR_CPR: 1,
                                })
                                setprueba([])
                            } else {
                                setDataAvailable(available.data);
                                setprueba(available.data)
                            }
                        }
                        else {
                            const available = await getDataConnectorGlobal(Id, tenant, 'Ctx.DataUsage', Type, nameregion);
                            if (available.data && available.data.error === 'id suscription invalido') {
                                setDataAvailablep(Array.isArray(available.data) ? available.data : []);
                                setprueba([])
                            } else {
                                setDataAvailablep([]);;
                                setprueba(available.data)
                            }
                        }

                    }
                    else if (Type !== 'CloudGlobal' && currentUser?.ListPermiso?.includes('Ctx.DataUsage')) {
                        if (tenant === 0) {
                            const available = await getDataConnector(Id, 'Ctx.DataUsage');
                            if (available.data && available.data.error === 'id suscription invalido') {
                                setDataAvailable({
                                    start: '', end: '', Available_DTR_VPN: 0, DateUpdate_DTR_VPN: '', exceeded_DTR_VPN: 0, Total_DTR_VPN: 1,
                                    Available_DTR_CPR: 0,
                                    DateUpdate_DTR_CPR: '',
                                    exceeded_DTR_CPR: 0,
                                    Total_DTR_CPR: 1,
                                })
                                setprueba([])
                            } else {
                                setDataAvailable(available.data);
                                setprueba(available.data)
                            }
                        }
                        else {
                            const available = await getDataConnectorGlobal(Id, tenant, 'Ctx.DataUsage');
                            if (available.data && available.data.error === 'id suscription invalido') {
                                setDataAvailable({
                                    start: '', end: '', Available_DTR_VPN: 0, DateUpdate_DTR_VPN: '', exceeded_DTR_VPN: 0, Total_DTR_VPN: 1,
                                    Available_DTR_CPR: 0,
                                    DateUpdate_DTR_CPR: '',
                                    exceeded_DTR_CPR: 0,
                                    Total_DTR_CPR: 1,
                                })
                                setprueba([])
                            } else {
                                setDataAvailable(available.data);
                                setprueba(available.data)
                            }
                        }

                    }
                }
            } catch (error) {
                console.error('Error al obtener las cuentas:', error);
            }
        };

        fetchData();
    }, [FlagReg, nameregion])

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (currentUser?.ListPermiso?.includes('Ctx.DataUsage')) {

                    if (tenant === 0) {
                        const available = await getDataConnector(Id === -1 ? -1 : Id, 'Ctx.DataUsage');
                        if (available.data && available.data.error === 'id suscription invalido') {
                            setDataAvailable({
                                start: '', end: '', Available_DTR_VPN: 0, DateUpdate_DTR_VPN: '', exceeded_DTR_VPN: 0, Total_DTR_VPN: 1,
                                Available_DTR_CPR: 0,
                                DateUpdate_DTR_CPR: '',
                                exceeded_DTR_CPR: 0,
                                Total_DTR_CPR: 1,
                            })
                            setprueba([])
                        } else {
                            setDataAvailable(available.data);
                            setprueba(available.data)
                            setDataAvailablep(available.data)

                        }
                    }
                    else {
                        const available = await getDataConnectorGlobal(Id, tenant, 'Ctx.DataUsage');
                        if (available.data && available.data.error === 'id suscription invalido') {
                            setDataAvailable({
                                start: '', end: '', Available_DTR_VPN: 0, DateUpdate_DTR_VPN: '', exceeded_DTR_VPN: 0, Total_DTR_VPN: 1,
                                Available_DTR_CPR: 0,
                                DateUpdate_DTR_CPR: '',
                                exceeded_DTR_CPR: 0,
                                Total_DTR_CPR: 1,
                            })
                            setprueba([])
                        } else {
                            setDataAvailable(available.data);
                            setprueba(available.data)
                            setDataAvailablep(available.data)

                        }
                    }

                }

            } catch (error) {
                console.error('Error al obtener las cuentas:', error);
            }
        };

        fetchData();
    }, [Id])

    let incluye
    let incluyeedge
    if (prueba) {
        for (const x of Object.keys(prueba)) {
            if (x.includes('CPR')) {
                incluye = x.includes('CPR')
            }
            if (x.includes('EDG')) {
                incluyeedge = x.includes('EDG')

            }
        }
    }

    ///////////////////////////////////

    let CPR
    for (const x of Object.keys(prueba)) {
        if (x.includes('CPR')) {
            CPR = x.includes('CPR')

        }
    }

    if (Type === 'CloudGlobal') {
        if (Array.isArray(DataAvailablep)) {
            for (const x of DataAvailablep) {
                if (x.Available_DTR_CPR) {
                    CPR = true;
                }
            }
        }
    }
    let EDG
    for (const x of Object.keys(prueba)) {
        if (x.includes('EDG')) {
            EDG = x.includes('EDG')

        }
    }

    if (Type === 'CloudGlobal') {
        if (Array.isArray(DataAvailablep)) {
            for (const x of DataAvailablep) {
                if (x.Available_DTR_EDG) {
                    EDG = true;
                }
            }
        }
    }
    let IPSEC
    for (const x of Object.keys(prueba)) {
        if (x.includes('VPN')) {
            IPSEC = x.includes('VPN')
        }
    }
    if (Type === 'CloudGlobal') {
        if (Array.isArray(DataAvailablep)) {
            for (const x of DataAvailablep) {
                if (x.Available_DTR_VPN) {
                    IPSEC = true;
                }
            }
        }
    }


    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    
    useEffect(() => {
        const delay = setTimeout(() => {
            if (ListaPermisosTenant.length > 0) {
                setLoading(false); // Detener el estado de loading cuando los permisos estén cargados
                
                if (!ListaPermisosTenant.includes('Ctx.DataUsage')) {
                    if (!ListaPermisosTenant.includes('Home.Status')) {
                        // Redirige a cloudConnectivity si no tiene Home.Status ni Ctx.DataUsage
                        navigate('/cloudConnectivity');
                    } else {
                        // Redirige a dashboard/status si tiene Home.Status pero no Ctx.DataUsage
                        navigate('/dashboard/status');
                    }
                }
            }
        }, 1000); // Retraso de 1 segundo
    
        // Limpiar timeout si el componente se desmonta
        return () => clearTimeout(delay);
    }, [ListaPermisosTenant, navigate]);

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column' }}>
                <Spinner animation="border" role="status" variant="primary">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
                <div className="text-marino" style={{ marginTop: '20px', fontSize: '18px', color: '#007bff' }}>We are validating your permissions...</div>
            </div>
        );
    }

    if (Id !== 0 && Id !== -1) {
        return (
            <>

                <div className='card mb-5 mb-xl-5'>
                    <div className="card-body d-flex flex-column ">
                        <div className="d-flex flex-column flex-row-fluid">
                            <div className="d-flex flex-column-auto h-70px border rounded flex-center bg-marino ">
                                <h3 className='f-titulo text-w fs-sub'> CTX Data Transfer Usage</h3>
                            </div>
                            <div className="d-flex flex-column-auto h-10px  flex-center">

                            </div>

                            <div className="d-flex flex-row flex-column-fluid ">
                                <div style={{ marginLeft: '15px' }} className="d-flex flex-row-fluid  flex-center col-5 ">
                                    {/*<GetLastUpdateDate source='Ctx.DataUsage'></GetLastUpdateDate>*/}
                                    <label className='form-label f-parrafo fs-p text-muted-azul '>Last Update Date: {DataAvailable?.DateUpdate_DTR_CPR}</label>
                                </div>
                            </div>


                            <div className="d-flex flex-column-auto   flex-center">
                                <div className="alert alert-info d-flex align-items-center p-5 mb-0">

                                    <div style={{ marginRight: '20px' }} className="d-flex flex-column">
                                        <h5 className="mb-1 f-parrafo fs-p text-center text-marino">OUTBOUND DATA TRANSFER AVAILABLE FOR CTX     </h5>
                                        <h5 className="mb-1  f-parrafo fs-6 text-pink text-center">Periodo: {DataAvailable.start} al {DataAvailable.end} </h5>

                                    </div>

                                </div>
                            </div>

                            <br />


                            <div className='row  gx-xl-10'>
                                {/*IPSEC&&<div className=" col-xl-6">
                        <IpsecconnectorVert id={2} source= 'Ctx.DataUsage' ></IpsecconnectorVert>
                            <br />
                    </div>*/}

                                {IPSEC && <div className=" col-xl-6">
                                    {
                                        DataAvailable.Available_DTR_VPN !== 0 &&
                                        <Pruebachart
                                            exedido={DataAvailable.exceeded_DTR_VPN}
                                            name='IPSec Connector'
                                            total={DataAvailable.Total_DTR_VPN}
                                            disponible={DataAvailable.Available_DTR_VPN}
                                            className='card-xl-stretch mb-xl-8'
                                            chartColor='marino'
                                            chartHeight={300}></Pruebachart>



                                    }

                                    {
                                        DataAvailable.Available_DTR_VPN === 0 &&
                                        <Pruebachart
                                            exedido={DataAvailable.exceeded_DTR_VPN}
                                            name='IPsec Connector'
                                            total={DataAvailable.Total_DTR_VPN}
                                            disponible={DataAvailable.Available_DTR_VPN}
                                            className='card-xl-stretch mb-xl-8'
                                            chartColor='danger'
                                            chartHeight={300}></Pruebachart>
                                    }
                                </div>}

                                {/*CPR &&<div  className="  col-xl-6">
                        <CloudconnectorVert id = {2} source= 'Ctx.DataUsage'></CloudconnectorVert>
                    </div>*/}

                                {CPR && <div className=" col-xl-6">
                                    {
                                        DataAvailable.Available_DTR_CPR !== 0 &&
                                        <Pruebachart
                                            exedido={DataAvailable.exceeded_DTR_CPR}
                                            name='Cloud Connector'
                                            total={DataAvailable.Total_DTR_CPR}
                                            disponible={DataAvailable.Available_DTR_CPR}
                                            className='card-xl-stretch mb-xl-8'
                                            chartColor='marino'
                                            chartHeight={300}></Pruebachart>
                                    }

                                    {
                                        DataAvailable.Available_DTR_CPR === 0 &&
                                        <Pruebachart
                                            exedido={DataAvailable.exceeded_DTR_CPR}
                                            name='Cloud Connector'
                                            total={DataAvailable.Total_DTR_CPR}
                                            disponible={DataAvailable.Available_DTR_CPR}
                                            className='card-xl-stretch mb-xl-8'
                                            chartColor='danger'
                                            chartHeight={300}></Pruebachart>
                                    }
                                </div>}

                                {!CPR && EDG && <div className="  col-xl-6">
                                    <Cloudconnectoredge id={2} source='Ctx.DataUsage'></Cloudconnectoredge>
                                </div>}


                            </div>
                            <div className='d-flex flex-center'>
                                {CPR && EDG && <div className="  col-xl-6">
                                    <Cloudconnectoredge id={2} source='Ctx.DataUsage'></Cloudconnectoredge>
                                </div>}
                            </div>
                            <div className="d-flex flex-column text-center">
                                <h5 className='f-parrafo text-marino'>NEXT AVAILABLE DATA TRANSFER RENEWAL FOR ALL CONNECTORS: {mesSiguiente}</h5>
                            </div>

                            <div style={{ marginBottom: '15px' }} className="d-flex flex-column-auto   flex-center">
                                <div className="alert alert-info d-flex align-items-center p-5 mb-0">
                                    <span className="svg-icon svg-icon-2hx svg-icon-primary me-3 ">
                                        <span className=" w-24 h-30 svg-icon svg-icon-2hx svg-icon-primary me-4">
                                            <svg viewBox="0 0 24 24" width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mh-50px">
                                                <path opacity="0.3"
                                                    fill="black"
                                                    d="M20.5543 4.37824L12.1798 2.02473C12.0626 1.99176 11.9376 1.99176 11.8203 2.02473L3.44572 4.37824C3.18118 4.45258 3 4.6807 3 4.93945V13.569C3 14.6914 3.48509 15.8404 4.4417 16.984C5.17231 17.8575 6.18314 18.7345 7.446 19.5909C9.56752 21.0295 11.6566 21.912 11.7445 21.9488C11.8258 21.9829 11.9129 22 12.0001 22C12.0872 22 12.1744 21.983 12.2557 21.9488C12.3435 21.912 14.4326 21.0295 16.5541 19.5909C17.8169 18.7345 18.8277 17.8575 19.5584 16.984C20.515 15.8404 21 14.6914 21 13.569V4.93945C21 4.6807 20.8189 4.45258 20.5543 4.37824Z">
                                                </path>
                                                <path d="M10.5606 11.3042L9.57283 10.3018C9.28174 10.0065 8.80522 10.0065 8.51412 10.3018C8.22897 10.5912 8.22897 11.0559 8.51412 11.3452L10.4182 13.2773C10.8099 13.6747 11.451 13.6747 11.8427 13.2773L15.4859 9.58051C15.771 9.29117 15.771 8.82648 15.4859 8.53714C15.1948 8.24176 14.7183 8.24176 14.4272 8.53714L11.7002 11.3042C11.3869 11.6221 10.874 11.6221 10.5606 11.3042Z" fill="black"></path>
                                            </svg>
                                        </span>
                                    </span>
                                    <div className="d-flex flex-column">
                                        <h5 className="mb-1 f-bold">Note</h5>
                                        <span className='f-parrafo'>Inbound data towards CTX is unlimited, The following charts refers only to outbound Data.</span>
                                    </div>
                                </div>
                            </div>


                            <GeneralDetail VPN={IPSEC} CPR={CPR} EDG={EDG}></GeneralDetail>

                        </div>
                    </div>
                </div>
            </>

        )
    }
    else {
        return (

            <>
                {Type === 'CloudGlobal' &&
                    <div className='card mb-5 mb-xl-5'>
                        <div className="card-body d-flex flex-column ">
                            <div className="d-flex flex-column flex-row-fluid">
                                <div className="d-flex flex-column-auto h-70px border rounded flex-center bg-marino ">
                                    <h3 className='f-titulo text-w fs-sub'> CTX Data Transfer Usage</h3>
                                </div>
                                <div className="d-flex flex-column-auto h-10px  flex-center">

                                </div>



                                {Array.isArray(DataAvailablep) && DataAvailablep.length > 0 && DataAvailablep.map((dato: any) => (
                                    <>
                                        <div className="d-flex flex-column-auto   flex-center">
                                            <div className="alert alert-info d-flex align-items-center p-5 mb-0">
                                                <div style={{ marginRight: '20px' }} className="d-flex flex-column">
                                                    <h5 className="mb-1 f-parrafo fs-p text-center">OUTBOUND DATA TRANSFER AVAILABLE FOR CTX</h5>
                                                    <h5 className="mb-1 f-parrafo fs-6 text-pink text-center">Periodo: {dato.start} al {dato.end}</h5>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="d-flex flex-row flex-column-fluid">
                                            <div style={{ marginLeft: '15px' }} className="d-flex flex-row-fluid flex-center col-5">
                                            </div>
                                        </div>
                                        <br />

                                        <div className='row  gx-xl-10'>
                                            <div className="col-xl-6">
                                                {dato.Available_DTR_VPN !== 0 ? <Pruebachart
                                                    exedido={dato.exceeded_DTR_VPN}
                                                    name='IPSec connector'
                                                    total={dato.Total_DTR_VPN}
                                                    disponible={dato.Available_DTR_VPN}
                                                    className='card-xl-stretch mb-xl-8'
                                                    chartColor='marino'
                                                    chartHeight={300}></Pruebachart>
                                                    :
                                                    <Pruebachart
                                                        exedido={dato.exceeded_DTR_VPN}
                                                        name='IPsec Connector'
                                                        total={dato.Total_DTR_VPN}
                                                        disponible={dato.Available_DTR_VPN}
                                                        className='card-xl-stretch mb-xl-8'
                                                        chartColor='danger'
                                                        chartHeight={300}></Pruebachart>
                                                }
                                                <br />
                                            </div>

                                            <div className="col-xl-6">
                                                {dato.Available_DTR_CPR !== 0 ?
                                                    <Pruebachart
                                                        exedido={dato.exceeded_DTR_CPR}
                                                        name='Cloud Connector'
                                                        total={dato.Total_DTR_CPR}
                                                        disponible={dato.Available_DTR_CPR}
                                                        className='card-xl-stretch mb-xl-8'
                                                        chartColor='marino'
                                                        chartHeight={300}></Pruebachart>
                                                    :
                                                    <Pruebachart
                                                        exedido={dato.exceeded_DTR_CPR}
                                                        name='Cloud Connector'
                                                        total={dato.Total_DTR_CPR}
                                                        disponible={dato.Available_DTR_CPR}
                                                        className='card-xl-stretch mb-xl-8'
                                                        chartColor='danger'
                                                        chartHeight={300}></Pruebachart>
                                                }
                                            </div>
                                        </div>

                                        <div className="d-flex flex-center">
                                            {dato.Available_DTR_EDG && dato.Available_DTR_EDG !== 0 ?
                                                <Pruebachart
                                                    exedido={dato.exceeded_DTR_EDG}
                                                    name='Edge Connector'
                                                    total={dato.Total_DTR_EDG}
                                                    disponible={dato.Available_DTR_EDG}
                                                    className='card-xl-stretch mb-xl-8'
                                                    chartColor='marino'
                                                    chartHeight={300}></Pruebachart>
                                                : dato.exceeded_DTR_EDG &&
                                                <Pruebachart
                                                    exedido={dato.exceeded_DTR_EDG}
                                                    name='Edge Connector'
                                                    total={dato.Total_DTR_EDG}
                                                    disponible={dato.Available_DTR_EDG}
                                                    className='card-xl-stretch mb-xl-8'
                                                    chartColor='danger'
                                                    chartHeight={300}></Pruebachart>
                                            }
                                        </div>
                                    </>
                                ))}

                                <div className="d-flex flex-column text-center">
                                    <h5 className='f-parrafo text-marino'>NEXT AVAILABLE DATA TRANSFER RENEWAL FOR ALL CONNECTORS: {mesSiguiente}</h5>
                                </div>

                                <div style={{ marginBottom: '15px' }} className="d-flex flex-column-auto   flex-center">
                                    <div className="alert alert-info d-flex align-items-center p-5 mb-0">
                                        <span className="svg-icon svg-icon-2hx svg-icon-primary me-3 ">
                                            <span className=" w-24 h-30 svg-icon svg-icon-2hx svg-icon-primary me-4">
                                                <svg viewBox="0 0 24 24" width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mh-50px">
                                                    <path opacity="0.3"
                                                        fill="black"
                                                        d="M20.5543 4.37824L12.1798 2.02473C12.0626 1.99176 11.9376 1.99176 11.8203 2.02473L3.44572 4.37824C3.18118 4.45258 3 4.6807 3 4.93945V13.569C3 14.6914 3.48509 15.8404 4.4417 16.984C5.17231 17.8575 6.18314 18.7345 7.446 19.5909C9.56752 21.0295 11.6566 21.912 11.7445 21.9488C11.8258 21.9829 11.9129 22 12.0001 22C12.0872 22 12.1744 21.983 12.2557 21.9488C12.3435 21.912 14.4326 21.0295 16.5541 19.5909C17.8169 18.7345 18.8277 17.8575 19.5584 16.984C20.515 15.8404 21 14.6914 21 13.569V4.93945C21 4.6807 20.8189 4.45258 20.5543 4.37824Z">
                                                    </path>
                                                    <path d="M10.5606 11.3042L9.57283 10.3018C9.28174 10.0065 8.80522 10.0065 8.51412 10.3018C8.22897 10.5912 8.22897 11.0559 8.51412 11.3452L10.4182 13.2773C10.8099 13.6747 11.451 13.6747 11.8427 13.2773L15.4859 9.58051C15.771 9.29117 15.771 8.82648 15.4859 8.53714C15.1948 8.24176 14.7183 8.24176 14.4272 8.53714L11.7002 11.3042C11.3869 11.6221 10.874 11.6221 10.5606 11.3042Z" fill="black"></path>
                                                </svg>
                                            </span>
                                        </span>
                                        <div className="d-flex flex-column">
                                            <h5 className="mb-1 f-bold">Note</h5>
                                            <span className='f-parrafo'>Inbound data towards CTX is unlimited, The following charts refers only to outbound Data.</span>
                                        </div>
                                    </div>
                                </div>


                                <GeneralDetail VPN={IPSEC} CPR={CPR} EDG={EDG}></GeneralDetail>

                            </div>
                        </div>
                    </div>}
                {Id === -1 && Type === 'CloudGlobal' && currentUser?.Tenant.Name !== 'DEMO' && currentUser?.Tenant.Name !== 'Telecom District' &&
                    <table className="table table-striped gy-7 gs-7">
                        <tbody>
                            <div className="text-center">
                                Select a Cloud with available subscriptions
                            </div>
                        </tbody>
                    </table>}
            </>


        )

    }
}

const DataTransferWrapper = () => {
    const intl = useIntl();
    return (
        <>
            <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.DASHBOARD' })}</PageTitle>
            <DataTransfer />
        </>
    );
};

export { DataTransfer, DataTransferWrapper }
